module.exports = __webpack_public_path__ + "static/media/Robert M. La Follette Sr. - 1924.a342f5c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Robert M. La Follette Sr. - 1924.jpg
// module id = 540
// module chunks = 0